import styled from 'styled-components';

export const StyledCctvWrapper = styled.div`
  position: absolute;
  top: 70px;
  right: 10px;
  z-index: 20;

  display: flex;
  flex-direction: column;

  width: 640px;

  background-color: #ffffff;
  border: 1px solid #c0c0c0;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.35);
  border-radius: 4px;
  overflow: hidden;

  user-select: none;
  touch-action: none;

  .title-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    padding: 0 8px 0 12px;
    /*background: linear-gradient(to bottom, #e8e8e8, #d0d0d0);*/
    border-bottom: 1px solid #b0b0b0;
    cursor: grab;
  }

  &.dragging .title-bar {
    cursor: grabbing;
  }

  .title-text {
    font-size: 13px;
    font-weight: 600;
    color: #1a1a1a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .close-btn {
    width: 20px;
    height: 20px;
    border: 1px solid #999;
    border-radius: 3px;
    /*background: linear-gradient(to bottom, #f5f5f5, #dcdcdc);*/
    color: #333;
    font-size: 11px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &:hover {
      /*background: linear-gradient(to bottom, #e0e0e0, #c8c8c8);*/
    }
  }

  .cctv-frame-wrapper {
    position: relative;
    width: 100%;
    height: 360px;
    background: #000;
  }

  .cctv-loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f0;
    z-index: 1;
  }

  .cctv-frame {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }
`;
